<template>
    <div class="end w-100 h-100 overflow-hidden">
        <div class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images?.ranking_podium_image}')`}"></div>
        <button type="button" class="btn btn-sm btn-outline-light position-absolute top-0 end-0 m-3 end-logout" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>

        <div class="d-flex justify-content-center align-items-start end-header position-absolute w-100" id="end-header-region">
            <h1  class="text-center mt-4" v-if="$store.state.game.styles" :style="$store.state.game.styles.ranking_end">FIN</h1>
        </div>
        <div class="position-absolute top-0 start-0 ms-5 p-0" id="logos">
            <div class="d-flex justify-content-center align-items-center flex-column text-center bg-light rounded-bottom p-3">
                <EventBrand />
            </div>
        </div>
        <div class="w-100 h-100 d-flex justify-content-center position-relative end-body" id="end-body-region" v-if="$store.state.game.styles" >
            <div class="h-100 d-flex justify-content-end align-items-center flex-column m-3 podium-el">
                <div class="line rounded top-100 d-flex justify-content-center align-items-center animate__animated animate__fadeInUp animate__delay-3 podium-2" :style="$store.state.game.styles.end_lines">
                    <div v-if="end_users[1]" class="position-absolute team-avatar team-text text-center w-100">
                        <span class="w-100 text-center" :style="$store.state.game.styles.ranking_end_teams">{{ utils.calc_score(end_users[1].data) }}</span><br>
                        <span class="w-100 text-center name" :style="$store.state.game.styles.ranking_end_teams">{{ end_users[1].username }}</span>
                        <TeamJerseyBadge v-if="end_users[1] && end_users[1].avatar_style && end_users[1].avatar_style.color" :color="end_users[1].avatar_style.color" :size="80" class="podium-jersey" />
                        <Avatar v-else-if="end_users[1]" class="podium-avatar" :username="end_users[1].username"></Avatar>
                    </div>
                    <span class="team-text pos d-flex justify-content-center align-items-center position-absolute bottom-0 mb-4 rounded-circle bg-dark">2</span>
                </div>
            </div>
            <div class="h-100 d-flex justify-content-end align-items-center flex-column m-3 podium-el">
                <div class="line rounded top-100 d-flex justify-content-center align-items-center animate__animated animate__fadeInUp animate__delay-2 podium-1" :style="$store.state.game.styles.end_lines">
                    <div v-if="end_users[0]" class="position-absolute team-avatar team-text text-center w-100">
                        <span class="w-100 text-center" :style="$store.state.game.styles.ranking_end_teams">{{ utils.calc_score(end_users[0].data) }}</span><br>
                        <span class="w-100 text-center name" :style="$store.state.game.styles.ranking_end_teams">{{ end_users[0].username }}</span>
                        <TeamJerseyBadge v-if="end_users[0] && end_users[0].avatar_style && end_users[0].avatar_style.color" :color="end_users[0].avatar_style.color" :size="80" class="podium-jersey" />
                        <Avatar v-else-if="end_users[0]" class="podium-avatar" :username="end_users[0].username"></Avatar>
                    </div>
                    <span class="team-text pos d-flex justify-content-center align-items-center position-absolute bottom-0 mb-4 rounded-circle bg-dark">1</span>
                </div>
            </div>
            <div class="h-100 d-flex justify-content-end align-items-center flex-column m-3 podium-el">
                <div class="line rounded top-100 d-flex justify-content-center align-items-center animate__animated animate__fadeInUp animate__delay-4 podium-3" :style="$store.state.game.styles.end_lines">
                    <div v-if="end_users[2]" class="position-absolute team-avatar team-text text-center w-100">
                        <span class="w-100 text-center" :style="$store.state.game.styles.ranking_end_teams">{{ utils.calc_score(end_users[2].data) }}</span><br>
                        <span class="w-100 text-center name" :style="$store.state.game.styles.ranking_end_teams">{{ end_users[2].username }}</span>
                        <TeamJerseyBadge v-if="end_users[2] && end_users[2].avatar_style && end_users[2].avatar_style.color" :color="end_users[2].avatar_style.color" :size="80" class="podium-jersey" />
                        <Avatar v-else-if="end_users[2]" class="podium-avatar" :username="end_users[2].username"></Avatar>
                    </div>
                    <span class="team-text pos d-flex justify-content-center align-items-center position-absolute bottom-0 mb-4 rounded-circle bg-dark">3</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBrand from '@/components/EventBrand.vue'
import utils from '@/../../shared/utils'
import Avatar from '@/components/Avatar.vue'
import TeamJerseyBadge from '@/components/TeamJerseyBadge.vue'
export default {
    name: 'End',
    components: { EventBrand,
        Avatar,
        TeamJerseyBadge
    },
    data(){
        return {
            idx: 0,
            percent_correct_answers: 0,
            total_score: null,
            utils: utils
        };
    },
    created() {
        window.addEventListener("resize", this.adjust_end);
    },
    unmounted() {
        window.removeEventListener("resize", this.adjust_end);
    },
    mounted() {
        console.log("End.vue mounted")
        this.adjust_end();

        if(window.store.state.network == "connected")
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))

        setTimeout(this.adjust_end,2000);
        $('.modal-backdrop').remove();
    },
    updated() {
        this.adjust_end();
    },
    computed: {
        end_users: function(){
            let users = this.$store.state.game.clients;

            let filtered_users = [];

            users.forEach((u) =>{
                if(u.role == this.utils.USER_ROLES.PLAYER)
                {
                    let score = utils.calc_score(u.data);
                    if(score > 0) {
                        u.score=score;
                        filtered_users.push(u);
                    }
                }
            });

            filtered_users.sort((a, b) => b.score - a.score);

            return filtered_users;
        }
    },
    methods: {
        logout(){
            this.utils.reset_client();
        },
        filter_winners() {
            let users = this.$store.state.game.clients;

            let filtered_users = [];

            users.forEach((u) =>{ 
                filtered_users.push({
                    user: u.user,
                    score: utils.calc_score(u.data)
                });
            });

            filtered_users.sort((a, b) => a.score - b.score);

            return filtered_users;
        },
        adjust_end() {
            var app = $("#app").height();
            var header = $("#end-header-region").outerHeight();
            if(app && header){
                $("#end-body-region").css({
                    paddingTop: header,
                });
            }
        }
    }
}
</script>

<style scoped>
    .end{
        background: radial-gradient(circle at 50% 20%, var(--vc-ink-700), var(--vc-ink-900) 65%);
        color: var(--vc-paper-50);
    }

    .team{
        font-family: "Archivo", sans-serif;
        font-size: 1vw;
    }

    .line{
        width: 100%;
    }

    .podium-el{
        width: 15vw;
    }
    .podium-1{
        height: calc(100% - 50%);
    }
    .podium-2{
        height: calc(85% - 50%);
    }
    .podium-3{
        height: calc(65% - 50%);
    }

    .team-avatar{
        top: -120px;
        color: var(--vc-paper-50);
    }

    .podium-avatar{
        width: 4.5vw;
        margin: 0 auto 0.5vw;
        border-radius: 999px;
        border: 2px solid var(--vc-paper-50);
    }

    .podium-jersey{
        margin: 0 auto 0.5vw;
    }

    .text-score{
        font-size: 1.7vw;
    }

    .name{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.9vw;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .pos {
        width: 4vw;
        height: 4vw;
        font-size: 2vw;
    }

    #logos{
        height: 150px;
        max-height: 150px;
        width: 20vw;
    }

    .end-logout{
        z-index: 30;
    }
</style>